
import Errors from 'Base/classes/Errors';
import Auth from 'Base/classes/Auth';
import Api from 'Base/classes/Api';
import Dispatch from 'Base/classes/Dispatch';
import parsePhoneNumber from 'libphonenumber-js'

export default (id) => ({
    id: id,
    user: {
        email: null,
        first_name: null,
        last_name: null,
        phone: "",
        password: null,
        g_recaptcha_response: null,
        privacy: true
    },
    phoneMenu : false,
    loading: false,
    errors: new Errors(),
    parsedPhoneNumber: "",
    isValidPhoneNumber: false,
    isParsingPhoneNumber: false,
    init()
    {
        this.user.phone = this.getPhonePrefix();
    },
    isValid()
    {
        return this.id && this.user.email && this.isValidPhoneNumber && !this.isParsingPhoneNumber && this.user.first_name && this.user.last_name;
    },
    validatePhoneNumber() {
        this.isParsingPhoneNumber = true;
        if (!this.user.phone) {
            this.invalidatePhoneNumber();
            this.isParsingPhoneNumber = false;
            return;
        }
        try {
            const phoneNumber = parsePhoneNumber(this.user.phone, this.getPhoneNumberCountryCode());
            this.isValidPhoneNumber = phoneNumber.isValid();
            this.parsedPhoneNumber = phoneNumber.format('E.164');
            this.user.phone = phoneNumber.format('INTERNATIONAL');
        } catch (error) {
            this.invalidatePhoneNumber();
        } finally {
            this.isParsingPhoneNumber = false;
        }
    },
    invalidatePhoneNumber() {
        this.isValidPhoneNumber = false;
        this.parsedPhoneNumber = "";
    },
    getPhoneNumberCountryCode() {
        if (window.current.country_code === "be") {
            return "BE";
        }

        if (window.current.country_code === "fr") {
            return "FR";
        }

        return undefined;
    },
    back()
    {
        new Dispatch(this, 'quote-previous-step', {step: 4});
    },
    save()
    {
        window.googleAnalyticsManager.pushEvent(window.googleAnalyticsManager.events.QUOTE_STEP, {
            step_name : 'login'
        });
        this.loading = true;
        this.errors.clear();

        new Auth().checkEmail(this.user.email)
            .then((data) => {
                new Dispatch(this, 'quote-next-step', {step: 4, user: { ...this.user, phone: this.parsedPhoneNumber || undefined }, exists: data.exists, user_id : data.user_id, no_password : data.no_password});
            })
            .catch((response) => {
                console.log(response);
                this.errors.record(response.data.errors);
                this.loading = false;
            });
    },
    getInputBorderColor(name)
    {
        return this.errors.has(name) ? 'border-color: #EF4444' : '';
    },
    replaceCountryCode(prefix) {
        if(!this.user.phone) this.user.phone = "";
        if(this.user.phone.startsWith("+32") || this.user.phone.startsWith("+33")) {
            this.user.phone = this.user.phone.replace(/^\+32|^\+33/, prefix);
        }
        else {
            this.user.phone = prefix + this.user.phone;
        }

        this.validatePhoneNumber();
        this.phoneMenu = false;
    },
    getPhonePrefix() {
            if(window.current.country_code === "be") {
                return "+32";
            }
            if(window.current.country_code === "fr") {
                return "+33";
            }
    }
});